import { createUrlWithSourceQueryParams, useAmplitude } from "@crehana/analytics";
import { CourseTypeEnum } from "../../../../__generated__/graphql-schema.v4";
import { CourseTypeEnum as CourseTypeEnumLegacy } from "../../../../Graphql/types";
import useSimpleCourseCardTranslation from "./useSimpleCourseCardTranslation";
var useSimpleCourseMainCTA = function useSimpleCourseMainCTA(_ref) {
  var course = _ref.course,
    user = _ref.user,
    disableRedirections = _ref.disableRedirections,
    onGoToCourseDashboard = _ref.onGoToCourseDashboard,
    onEnrollToCourse = _ref.onEnrollToCourse,
    onGoToCourseDetail = _ref.onGoToCourseDetail,
    source = _ref.source,
    sourceDetail = _ref.sourceDetail,
    _ref$shouldTrackSOFEM = _ref.shouldTrackSOFEMembership,
    shouldTrackSOFEMembership = _ref$shouldTrackSOFEM === void 0 ? false : _ref$shouldTrackSOFEM,
    SOFEEnrollmentSource = _ref.SOFEEnrollmentSource;
  var _useAmplitude = useAmplitude(),
    logEvent = _useAmplitude.logEvent;
  var _useSimpleCourseCardT = useSimpleCourseCardTranslation(),
    t = _useSimpleCourseCardT.t;
  var enrollmentUrl = createUrlWithSourceQueryParams({
    url: course.enrollmentUrl || "/enrollment/".concat(course.originalId, "/"),
    source: source,
    sourceDetail: sourceDetail
  });
  var courseDetailUrl = course.url ? createUrlWithSourceQueryParams({
    url: course.url,
    source: source,
    sourceDetail: sourceDetail
  }) : undefined;
  var canEnrollToCourse = !disableRedirections || onEnrollToCourse;
  var canGoToCourseDashboard = !disableRedirections || onGoToCourseDashboard;
  var canGoToCourseDetail = !disableRedirections && courseDetailUrl || onGoToCourseDetail;

  // If the user is already enrolled, they can go to the classroom
  if (course.isEnrollment && canGoToCourseDashboard) {
    return {
      label: t('SCC_GO_TO_CLASSROOM'),
      onClick: onGoToCourseDashboard ? function () {
        return onGoToCourseDashboard({
          course: course,
          courseId: course.originalId,
          source: source,
          sourceDetail: sourceDetail
        });
      } : undefined,
      href: !disableRedirections ? course.dashboardUrl || "/clases/v2/".concat(course.originalId, "/") : undefined
    };
  }

  // If the user is premium, the enrollment is available
  if (user !== null && user !== void 0 && user.isPremium && canEnrollToCourse) {
    // Particular case for tracking SOFE membership enrollments
    if (shouldTrackSOFEMembership && user.isSofeMembership) {
      return {
        label: t('SCC_ENROLL_NOW'),
        onClick: function onClick() {
          logEvent({
            event: 'Course Enrolled',
            data: {
              Source: SOFEEnrollmentSource,
              'Course Type': course.courseType,
              EnrollmentType: 'SOFE Membership'
            }
          });
          if (onEnrollToCourse) {
            onEnrollToCourse({
              course: course,
              courseId: course.originalId,
              source: source,
              sourceDetail: sourceDetail
            });
          } else {
            window.location.href = enrollmentUrl;
          }
        },
        href: undefined
      };
    }
    return {
      label: t('SCC_ENROLL_NOW'),
      onClick: onEnrollToCourse ? function () {
        return onEnrollToCourse({
          course: course,
          courseId: course.originalId,
          source: source,
          sourceDetail: sourceDetail
        });
      } : undefined,
      href: !disableRedirections ? enrollmentUrl : undefined
    };
  }

  // If the course is free, the enrollment is available
  if ((course.courseType === CourseTypeEnumLegacy.COURSE_TYPE_FREE || course.courseType === CourseTypeEnum.FREE || course.courseType === 'free') && canEnrollToCourse) {
    return {
      label: t('SCC_ENROLL_FREE'),
      onClick: onEnrollToCourse ? function () {
        return onEnrollToCourse({
          course: course,
          courseId: course.originalId,
          source: source,
          sourceDetail: sourceDetail
        });
      } : undefined,
      href: !disableRedirections ? enrollmentUrl : undefined
    };
  }
  if (canGoToCourseDetail) {
    return {
      label: t('SCC_COURSE_DETAIL'),
      onClick: onGoToCourseDetail ? function () {
        return onGoToCourseDetail({
          course: course,
          courseId: course.originalId,
          source: source,
          sourceDetail: sourceDetail
        });
      } : undefined,
      href: !disableRedirections ? courseDetailUrl || '' : undefined
    };
  }

  // If none of the above are available, the main cta button should not be rendered
  return undefined;
};
export default useSimpleCourseMainCTA;